module.exports = __webpack_public_path__ + "static/media/48.c0e720e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/48.jpg
// module id = 991
// module chunks = 0